import React from "react";
import { Link } from "react-router-dom";
import "../style/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      
      {/* Page Header */}
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>
          <Link to="/">Home</Link> <span>/</span> Privacy Policy
        </p>
      </div>

      {/* Content */}
      <div className="privacy-content">

        <section>
          <h2>Introduction</h2>
          <p>
            <strong>PFA Logistics Pvt. Ltd.</strong> is a professional logistics
            and supply chain company driven by experienced industry experts.
            We are committed to delivering reliable, prompt, and transparent
            logistics services to customers across India and worldwide.
          </p>
          <p>
            PFA Logistics Pvt. Ltd. strives to build long-term partnerships by
            offering innovative logistics solutions and consistently meeting
            customer expectations through service excellence.
          </p>
        </section>

        <section>
          <h2>Ownership of Rights</h2>
          <p>
            Any use of this website or its contents, including copying, storing,
            or reproducing any part of it, other than for personal and
            non-commercial use, is strictly prohibited without prior written
            permission from <strong>PFA Logistics Pvt. Ltd.</strong>
          </p>
          <p>
            All information, content, images, and materials displayed on this
            website are protected by copyright and intellectual property laws
            and are owned by or licensed to PFA Logistics Pvt. Ltd.
          </p>
          <p>
            You may not modify, distribute, publish, transmit, sell, or
            commercially exploit any content from this website.
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            All information, services, images, and content on this website are
            provided “as is” without any warranties, whether express or implied,
            including fitness for a particular purpose.
          </p>
          <p>
            Users should independently verify any information before relying on
            it. The content provided here does not constitute professional or
            legal advice.
          </p>
          <p>
            In no event shall <strong>PFA Logistics Pvt. Ltd.</strong> be liable
            for any direct, indirect, incidental, or consequential damages
            arising from the use of this website.
          </p>
          <p>
            All trademarks, logos, and brand names remain the property of their
            respective owners.
          </p>
        </section>

        <section>
          <h2>Disabling Cookies</h2>
          <p>
            You have the option to accept or disable cookies while using this
            website. Your preferences will be respected and applied accordingly
            to improve your browsing experience.
          </p>
        </section>

        <section>
          <h2>More Information</h2>
          <p>
            If you have any questions or need further clarification regarding
            this Privacy Policy, please contact us at{" "}
            <a href="mailto:info@zedexsoftware.com">
              info@zedexsoftware.com
            </a>.
          </p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
